import { useEffect } from 'react';

import AnalyticsHelper from '../Helper/Analytics';

type UsePageViewProps = (props: {
  enabled?: boolean;
  screenName: string;
  [key: string]: any;
}) => void;

const usePageView: UsePageViewProps = ({
  enabled = true,
  screenName,
  ...data
}) => {
  useEffect(() => {
    if (enabled) {
      setTimeout(() => {
        AnalyticsHelper.logScreenView(screenName, data);
      }, 0); // for defering the dispatch on redux so it won't block the ui
    }
  }, [enabled]);

  return null;
};

export default usePageView;
